import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { getActiveOrderProduct } from "ducks/order/selectors";
import { updateOrderProductSeasoning } from "ducks/orderProduct";
import { getActiveOrderProductCrustSeasoning } from "ducks/orderProduct/selectors";
import { getSelfLink } from "selectors/related";

import kebabCase from "modules/kebabCase";

const CrustSeasoning = ({
  seasonings,
  seasoningOptionCode,
  seasoningOptionNameKey,
  t = () => {},
}) => {
  const dispatch = useDispatch();
  const activeOrderProduct = useSelector(getActiveOrderProduct);
  const activeOrderProductLink = getSelfLink(activeOrderProduct);

  const { code: activeSeasoningOption } = useSelector(
    getActiveOrderProductCrustSeasoning(seasonings)
  );

  const handleSauceOptionClick = () =>
    dispatch(
      updateOrderProductSeasoning({
        ...activeOrderProduct,
        url: activeOrderProductLink,
        seasonings,
        seasoningOptionCode,
      })
    );

  const isActive = activeSeasoningOption === seasoningOptionCode;

  return (
    <button
      className={classNames("btn", isActive && "btn--fill")}
      data-quid={kebabCase(seasoningOptionNameKey)}
      key={seasoningOptionCode}
      onClick={handleSauceOptionClick}
      type="button"
    >
      {t(seasoningOptionNameKey)}
    </button>
  );
};

CrustSeasoning.propTypes = {
  seasonings: PropTypes.arrayOf(PropTypes.object).isRequired,
  seasoningOptionCode: PropTypes.string.isRequired,
  seasoningOptionNameKey: PropTypes.string.isRequired,
  t: PropTypes.func,
};

export { CrustSeasoning };
